import { render, staticRenderFns } from "./replyPopup.vue?vue&type=template&id=5ca1c96e&scoped=true&"
import script from "./replyPopup.vue?vue&type=script&lang=js&"
export * from "./replyPopup.vue?vue&type=script&lang=js&"
import style0 from "./replyPopup.vue?vue&type=style&index=0&id=5ca1c96e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ca1c96e",
  null
  
)

export default component.exports